import { Common } from '../common';
import {
  CopilotSession,
  CreateValues,
  Payload,
} from '../models/orchestrator/copilot/session';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async create(values: CreateValues): Promise<Payload> {
    const url = this.common.constructPath('/copilot/sessions');
    const { session, job } = await this.common.postJSON(url, values);
    return { session, job };
  }

  async findAll(): Promise<CopilotSession[]> {
    const url = this.common.constructPath('/copilot/sessions');
    return await this.common.getJSON(url);
  }

  async destroy(id: string): Promise<void> {
    const url = this.common.constructPath(`/copilot/sessions/${id}`);
    return await this.common.deleteJSON(url);
  }

  async extend(id: string): Promise<CopilotSession> {
    const url = this.common.constructPath(`/copilot/sessions/${id}/extend`);
    return await this.common.patchJSON(url);
  }
}
